import { Button } from 'reactstrap';
import { FileWithAiProcessing } from '../../../../types/document';
import './DocumentUploadItem.scss';
import { Toggle } from '@g17eco/molecules/toggle';
import { allowAIProcessing } from '@utils/ai';

interface DocumentUploadItemProps {
  fileWithAi: FileWithAiProcessing;
  onToggleAiProcessing: (fileId: string) => void;
  onRemoveFile: (fileId: string) => void;
}

export const DocumentUploadItem = (props: DocumentUploadItemProps) => {
  const { fileWithAi, onToggleAiProcessing, onRemoveFile } = props;

  return (
    <div className='document-upload-preview-item d-flex align-items-center gap-3 px-2'>
      <div className='d-flex align-items-center gap-2 flex-shrink-0'>
        <Toggle
          checked={allowAIProcessing(fileWithAi)}
          onChange={() => onToggleAiProcessing(fileWithAi.id)}
          testId={`ai-toggle-${fileWithAi.id}`}
        />
      </div>

      <div className='flex-grow-1 text-truncate'>
        <span className='file-name'>{fileWithAi.file.name}</span>
      </div>

      <div className='remove-wrapper flex-shrink-0'>
        <Button
          color='link'
          className='text-danger p-0 remove-btn'
          onClick={() => onRemoveFile(fileWithAi.id)}
          data-testid={`remove-${fileWithAi.id}`}
          aria-label={`Remove ${fileWithAi.file.name}`}
        >
          <i className='fal fa-xmark fa-lg' />
        </Button>
      </div>
    </div>
  );
};
